import { type UploadOptions, defaultOptions } from "tus-js-client";
export interface IDicomUploadTusFingerprintStore {
    clearFingerprintsFromLocalStorage(): void;
}

export class DicomUploadTusFingerprintStore implements IDicomUploadTusFingerprintStore {
    public static readonly DicomUploadFingerprintPrefix = "dicom-upload-";

    public static async generate(file: File, options: UploadOptions): Promise<string> {
        const defaultFingerprint = await defaultOptions.fingerprint(file, options);

        return DicomUploadTusFingerprintStore.DicomUploadFingerprintPrefix + defaultFingerprint;
    }

    public clearFingerprintsFromLocalStorage(): void {
        if (!window.localStorage) {
            return;
        }

        const localStorageKeysToRemove: string[] = [];

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);

            if (!key) {
                continue;
            }

            if (!key.startsWith("tus::" + DicomUploadTusFingerprintStore.DicomUploadFingerprintPrefix)) {
                continue;
            }

            localStorageKeysToRemove.push(key);
        }

        for (const key of localStorageKeysToRemove) {
            localStorage.removeItem(key);
        }
    }
}
